import Product from './components/product.vue';
import CustomProduct from './components/custom/product.vue';

import OrderManager from './components/orderManager.vue';

import Summary from './components/components/summary.vue';
import Information from './components/components/information.vue';
import Delivery from './components/components/delivery.vue';
import Approve from './components/components/approve.vue';
import Payment from './components/components/payment.vue';

import CustomSummary from './components/custom/components/summary.vue';
import CustomInformation from './components/custom/components/information.vue';
import CustomDelivery from './components/custom/components/delivery.vue';
import CustomApprove from './components/custom/components/approve.vue';
import CustomPayment from './components/custom/components/payment.vue';
import CustomOrderComplete from './components/custom/components/completedOrder.vue';
import CustomOrderFailed from './components/custom/components/failedOrder.vue';
import CustomCardFailed from './components/custom/components/failedCard.vue';

import OrderComplete from './components/completedOrder.vue';
import OrderFailed from './components/failedOrder.vue';
import CardFailed from './components/failedCard.vue';

export const routes = [
    {path: '/', name:'product', component:Product},
    {path: '/custom', name:'custom.product', component:CustomProduct},

    {path: '/order', name:'order', component:OrderManager, redirect: {name: 'order.summary'},
        children:[
            { path:'summary', name:'order.summary', component:Summary },
            { path:'information', name:'order.information', component:Information },
            { path:'delivery', name:'order.delivery', component:Delivery },
            { path:'approve', name:'order.approve', component:Approve },
            { path:'payment', name:'order.payment', component:Payment },
    ]},

    {path: '/custom/order', name:'custom.order', component:OrderManager, redirect: {name: 'custom.order.summary'},
        children:[
            { path:'summary', name:'custom.order.summary', component:CustomSummary},
            { path:'information', name:'custom.order.information', component:CustomInformation },
            { path:'delivery', name:'custom.order.delivery', component:CustomDelivery },
            { path:'approve', name:'custom.order.approve', component:CustomApprove },
            { path:'payment', name:'custom.order.payment', component:CustomPayment },
            { path:'complete', name:'custom.order.complete', component:CustomOrderComplete},
            {path: 'failed', name:'custom.order.failed', component:CustomOrderFailed},
            {path: 'card/failed', name:'custom.order.card.failed', component:CustomCardFailed},
        ]},

    {path: '/order/complete', name:'order.complete', component:OrderComplete},
    {path: '/order/failed', name:'order.failed', component:OrderFailed},
    {path: '/order/card/failed', name:'order.card.failed', component:CardFailed},
];
